import { render } from "./BookTeacherButton.vue?vue&type=template&id=3a4b71f8&scoped=true"
import script from "./BookTeacherButton.vue?vue&type=script&lang=js"
export * from "./BookTeacherButton.vue?vue&type=script&lang=js"

import "./BookTeacherButton.vue?vue&type=style&index=0&id=3a4b71f8&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-3a4b71f8"

export default script